import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";

class InvoiceFromQuoteCreatedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            proposal: nextProps.proposal || null,
            quote: nextProps.quote || null,
        })
    }

    render() {

        return <div className={"row " + this.state.className}>
            <div className="col-12">
                <p className={'mb-0'}>
                    <FormattedMessage
                        id="quote.analytics.events.invoice_created.text"
                        defaultMessage="The invoice {invoice} has been created from the proposal {quote}"
                        values={{
                            invoice: <strong>
                                <Link to={'/invoices/' + this.state.object.id + '/edit'}>
                                    {this.state.object.attributes.identifier}
                                </Link>
                            </strong>,
                            quote: <strong>{this.state.quote.attributes.identifier}</strong>,
                        }}
                    />
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-5'}>
                    <h3 className={"m-0"}>
                        <Icon value={"invoice"}/>
                    </h3>
                </div>
                <div className={'mr-5'}>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label">
                            <strong>
                                <FormattedMessage
                                    id="quote.analytics.events.invoice_created.total_amount"
                                    defaultMessage="Total amount"
                                />
                            </strong>
                        </label>
                    </div>
                    <h4 className={"m-0"}>
                        <FormattedNumber
                            value={this.state.object.attributes.totalAmount}
                            style={'currency'}
                            currency={this.state.object.attributes.currency}
                        />
                    </h4>
                </div>
                {this.state.object.attributes.status !== 'fully-paid' ? <div>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label">
                            <strong>
                                <FormattedMessage
                                    id="quote.analytics.events.invoice_created.balance"
                                    defaultMessage="Balance"
                                />
                            </strong>
                        </label>
                    </div>
                    <h4 className={"m-0"}>
                        <FormattedNumber
                            value={this.state.object.attributes.balance}
                            style={'currency'}
                            currency={this.state.object.attributes.currency}
                        />
                    </h4>
                </div> : ''}

            </div>
        </div>
    }

}

export default InvoiceFromQuoteCreatedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-from-quote-created.component.jsx